import { render, staticRenderFns } from "./createSystem.vue?vue&type=template&id=5b482d5e"
import script from "./createSystem.vue?vue&type=script&lang=js"
export * from "./createSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports